import { HttpTypes } from '@/types';
import { IStorePreferences } from '@/types/storepreferences';
import { AxiosInstance } from 'axios';

class Preferences {
  private client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async get(): Promise<HttpTypes.IResponse<IStorePreferences>> {
    const res = await this.client.get('/sites/preferences');
    return res.data;
  }

  async upsert(data: IStorePreferences): Promise<HttpTypes.IResponse<IStorePreferences>> {
    const res = await this.client.post('/sites/preferences', data);
    return res.data;
  }
}

export default Preferences;
